import { useIsAuth } from 'feature/auth/hooks'
import { useNavigate } from 'react-router'
import { useAppSelector } from 'store/hooks'

import { orderFormSpace } from '../namespaces/orderFormSpace'

import { useSendConsultForm } from './useSendConsultForm'
import { useSendOrderForm } from './useSendOrderForm'

// отсылка заявки
export const useSendForm = () => {
  const isAuth = useIsAuth()
  const navigate = useNavigate()
  const sendOrderForm = useSendOrderForm()
  const { sendForm: sendConsultForm, isError } = useSendConsultForm()
  const currentSendForm = useAppSelector(
    state => state.orderForm.currentSendForm,
  )
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const userType = useAppSelector(state =>
    currentEditForm in orderFormSpace.FormType
      ? state.orderForm.forms[currentEditForm as orderFormSpace.FormType]
          .userType
      : null,
  )

  const sendForm = ({
    forceNavigate = true,
  }: { forceNavigate?: boolean } = {}) => {
    if (isAuth) {
      if (currentSendForm in orderFormSpace.FormType) {
        sendOrderForm()
      }
      if (currentSendForm in orderFormSpace.ConsultationFormType) {
        sendConsultForm()
        return { isError: isError }
      }

      return { isError: false }
    }
    if (forceNavigate) {
      const loginPath = userType === 'company' ? '/company/login' : '/login'
      navigate(loginPath, {
        state: { sendingForm: true, redirectToAppeal: false },
      })
    }
  }

  return { sendForm, isError }
}
